import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';

// if (environment.production) {
//   console.log = () => {};
//   console.debug = () => {};
//   console.info = () => {};
//   // console.warn & console.error dibiarkan hidup, tetap berguna buat debug production
// }

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
